import _ from 'lodash'
import store from '../store'

export function getOnlyShowDomainListBySiteId (siteId) {
  let list = _.get(
    store.state.userInfo,
    `extra_json.onlyShowDomainMap[${siteId}]`
  )
  if (Array.isArray(list)) {
    return list
  }
  return []
}
